export default "__VITE_ASSET__t4tgNC0c__$_?url__"